import React from "react";

import { withTranslation } from "react-i18next";

import withNotification from "@hooks/useNotification";
import { SvgCancelAction } from "@routes/IconeSvg";
import Dropzone from "react-dropzone-uploader";
import "react-dropzone-uploader/dist/styles.css";

import "@assets/css/components/fileUpload.css";
import galleryIcon from "@assets/image/icones/galleryIcon.svg";
import galleryIconGreen from "@assets/image/icones/galleryIconGreen.png";
import "@css/components/inputFile.css";

import {
  MAX_SIZE_FOR_INPUTFILE_IN_MODAL_CERTIFICATION,
  ERROR_UPLOAD_FILES,
} from "@helpers/_constants";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isGreen: false,
    };
    this.inputFile = React.createRef();
  }

  customInput = () => {
    return (
      <div className={`${this.props.entreprise && "arh-flex "} drag_text`}>
        {/* <img src={galleryIcon} alt="" /> */}
        {!this.props.otherIcon ? (
          this.props.isGreen ? (
            <img src={galleryIconGreen} alt="" />
          ) : (
            <img src={galleryIcon} alt="" />
          )
        ) : (
          <img src={this.props.otherIcon} alt="" />
        )}
        {
          this.props.entreprise ?
            <div>
              <p>
                {this.props.t("Glissez-déposez votre fichier ici, ou")}{" "}
                <span>{this.props.t("sélectionnez un fichier")}</span>
              </p>
              <span className={this.props.classOther}>{this.props.fileType}</span>
            </div>
            :
            <>
              <p>
                {this.props.t("Glissez-déposez votre fichier ici, ou")}{" "}
                <span>{this.props.t("sélectionnez un fichier")}</span>
              </p>
              <span className={this.props.classOther}>{this.props.fileType}</span>
            </>

        }
      </div>
    );
  };

  removeFile = () => {
    this.inputFile.current.files[0].remove();
    this.props.removeDefaultFile();
  };

  Preview = ({ meta, dropzoneProps }) => {
    const { previewUrl } = meta;
    return (
      <>
        <div
          className={
            " filePreview preview_image_upload_content " +
            this.props.classPreviewFile
          }
        >
          <img
            alt=".."
            src={previewUrl}
            className="preview_image_banner arh-aspect-auto arh-h-full arh-w-full arh-object-contain"
          />
        </div>
        <div className="arh-group arh-absolute arh-h-full arh-w-full arh-p-6 hover:arh-flex hover:arh-bg-black/50">
          <div
            className="arh-invisible arh-absolute arh-top-[1.5rem] arh-right-[1.5rem] arh-flex arh-h-auto arh-w-auto arh-items-end arh-justify-end group-hover:arh-visible "
            onClick={this.removeFile}
          >
            {SvgCancelAction()}
          </div>
        </div>
      </>
    );
  };

  handleChangeStatus = (fileWithMeta, status, files) => {
    if (ERROR_UPLOAD_FILES.includes(status)) {
      this.props.showError(status);
      fileWithMeta.remove();
    } else {
      this.props.handleChangeStatus(fileWithMeta, status, files);
    }
  };

  render() {
    return (
      <div className="form_group arh-h-full arh-w-full">
        {this.props.label && (
          <label className="arh-font-poppins arh-text-xs arh-font-medium arh-text-black">
            {this.props.label}
            <span className="tips">{this.props.tips}</span>
          </label>
        )}
        {this.props.url ? (
          <div className="fileDefaultPreview">
            <div
              className={
                "preview_image_upload_content " + this.props.classPreviewFile
              }
            >
              <img
                alt=".."
                src={this.props.url}
                className="arh-h-full arh-w-full arh-object-contain "
              />
            </div>
            <div
              className="previewDelete"
              onClick={this.props.removeDefaultFile}
            >
              {SvgCancelAction()}
            </div>
          </div>
        ) : (
          <div className={`filePreview ${this.props.ClassfilePreview}`}>
            <Dropzone
              ref={this.inputFile}
              onChangeStatus={this.handleChangeStatus}
              accept="image/*"
              maxFiles={1}
              multiple={false}
              inputContent={this.customInput}
              maxSizeBytes={MAX_SIZE_FOR_INPUTFILE_IN_MODAL_CERTIFICATION}
              classNames={{
                dropzone: `${this.props.className}`,
                dropzoneActive: "file_upload_wrapper--active",
              }}
              SubmitButtonComponent={null}
              PreviewComponent={(props) => (
                <this.Preview {...props} extraProp={10} />
              )}
            />
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation("components.uploadFile", { withRef: true })(
  withNotification(Index),
);
